import './App.css';
import MinimalHome from './MinimalHome';
import { Routes, Route } from 'react-router-dom';

// Preserving old imports for legacy route
import './Header.css';
import './Arrow.css';
import './Gallery.css';
import './BlankHeadsMintPage.css';
import Footer from './Footer';
import Header from './Header';
// eslint-disable-next-line no-unused-vars
import ArrowDown from './ArrowDown';
import Gallery from './Gallery';
// eslint-disable-next-line no-unused-vars
import BlankHeadsMintPage from './BlankHeadsMintPage';
import AboutPopup from './AboutPopup';
import ArtHero from './ArtHero';
import ProjectIntro from './ProjectIntro';
import HashGallery from './HashGallery';
import FloatingGallery from './FloatingGallery';
import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

// Legacy App Component
const LegacyApp = () => {
  const [content, setContent] = useState('featured');
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [selectedArtist, setSelectedArtist] = useState(null);

  // Listen for custom navigation events
  useEffect(() => {
    const handleNavigateToHome = () => {
      setContent('featured');
      setIsAboutOpen(false);
    };
    
    const handleNavigateToGallery = () => {
      setContent('gallery');
      setIsAboutOpen(false);
    };
    
    const handleOpenAboutPopup = () => {
      setIsAboutOpen(true);
    };
    
    window.addEventListener('navigateToHome', handleNavigateToHome);
    window.addEventListener('navigateToGallery', handleNavigateToGallery);
    window.addEventListener('openAboutPopup', handleOpenAboutPopup);
    
    return () => {
      window.removeEventListener('navigateToHome', handleNavigateToHome);
      window.removeEventListener('navigateToGallery', handleNavigateToGallery);
      window.removeEventListener('openAboutPopup', handleOpenAboutPopup);
    };
  }, []);

  const switchContent = (newContent, artistId = null) => {
    if (newContent === 'about') {
      setIsAboutOpen(true);
    } else {
      setContent(newContent);
      setSelectedArtist(artistId);
      setIsAboutOpen(false);
    }
  };

  return (
    <div className="App">
      <Header switchContent={switchContent} />
      <AnimatePresence>
        {content !== 'gallery' && (
          <div key="featured">
            <HashGallery />
            <ArtHero />
            <FloatingGallery />
            <ProjectIntro />
          </div>
        )}
        {content === 'gallery' && (
          <motion.div
            key="gallery"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Gallery selectedArtist={selectedArtist} />
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {isAboutOpen && (
          <motion.div
            key="about"
            className="about-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <AboutPopup onClose={() => setIsAboutOpen(false)} />
          </motion.div>
        )}
      </AnimatePresence>
      <Footer />
    </div>
  );
};

// App Component
function App() {
  return (
    <Routes>
      <Route path="/" element={<LegacyApp />} />
      <Route path="/minimal" element={<MinimalHome />} />
    </Routes>
  );
}

export default App;
